// Player + staff data for the AS Roma 1982/83 squad.
// Positions are % coordinates over the LANDSCAPE framed photograph (IMAGES[0], natural 1080x810).
// Calibrated against actual face centers via AI vision analysis + manual verification.

export const PLAYERS = [
  // ============ BACK ROW (in piedi in alto) — y ~ 30% ============
  {
    id: "scarnecchia",
    name: "Aurelio Scarnecchia",
    role: { it: "Portiere · Riserva", en: "Goalkeeper · Reserve" },
    row: "back", face: { x: 8.3, y: 21.6 },
    stats: { it: "Portiere di riserva della rosa Scudetto.", en: "Reserve goalkeeper in the Scudetto squad." },
    fact: {
      it: "Cresciuto nel vivaio giallorosso, ha vestito la maglia della Roma come terzo portiere durante l'anno del secondo tricolore.",
      en: "Youth product of Roma, he wore the giallorossi shirt as third-choice goalkeeper during the season of the second league title."
    }
  },
  {
    id: "faccini",
    name: "Diego Faccini",
    role: { it: "Centrocampista · Giovane", en: "Midfielder · Youth" },
    row: "back", face: { x: 16.9, y: 20.5 },
    stats: { it: "Rosa allargata, giovane della Primavera.", en: "Extended squad, from Primavera academy." },
    fact: {
      it: "Fece parte della rosa allargata dello Scudetto pur non totalizzando presenze in prima squadra.",
      en: "Part of the extended Scudetto squad without first-team appearances that season."
    }
  },
  {
    id: "dibartolomei",
    name: "Agostino Di Bartolomei",
    role: { it: "Capitano · Regista arretrato", en: "Captain · Deep-lying playmaker" },
    row: "back", face: { x: 26.1, y: 19.6 },
    stats: { it: "28 presenze · 7 gol in Serie A · Capitano dello Scudetto.", en: "28 apps · 7 goals in Serie A · Scudetto-winning captain." },
    fact: {
      it: "Cuore romanista e simbolo della squadra: alzò la coppa dello Scudetto l'8 maggio 1983 dopo il pari con il Genoa. Il suo tiro dalla lunga distanza e i calci piazzati furono decisivi in tutta la stagione.",
      en: "Roma-born through and through, he lifted the Scudetto trophy on 8 May 1983 after the draw with Genoa. His long-range shooting and set pieces proved decisive throughout the season."
    }
  },
  {
    id: "chierico",
    name: "Odoacre Chierico",
    role: { it: "Centrocampista", en: "Midfielder" },
    row: "back", face: { x: 35.7, y: 19.9 },
    stats: { it: "16 presenze · 2 gol in Serie A.", en: "16 apps · 2 goals in Serie A." },
    fact: {
      it: "Jolly di centrocampo utilizzato da Liedholm sia come mezzala sia in fase di copertura nelle rotazioni della stagione.",
      en: "Midfield utility man, deployed by Liedholm as an inside midfielder and as a cover option in the season's rotations."
    }
  },
  {
    id: "biagini",
    name: "Fabio Biagini",
    role: { it: "Difensore · Giovane", en: "Defender · Youth" },
    row: "back", face: { x: 45.1, y: 20.2 },
    stats: { it: "Rosa allargata, prodotto del vivaio.", en: "Extended squad, youth academy product." },
    fact: {
      it: "Difensore della Primavera aggregato alla prima squadra nell'anno del secondo tricolore.",
      en: "Primavera defender promoted to the senior squad during the second Scudetto season."
    }
  },
  {
    id: "pruzzo",
    name: "Roberto Pruzzo",
    role: { it: "Centravanti", en: "Centre-forward" },
    row: "back", face: { x: 54.5, y: 19.9 },
    stats: { it: "27 presenze · 12 gol in Serie A · Capocannoniere della squadra.", en: "27 apps · 12 goals in Serie A · Team top scorer." },
    fact: {
      it: "\"O Rey di Crocefieschi\". Il suo colpo di testa contro il Genoa l'8 maggio 1983 valse il pareggio che consegnò aritmeticamente lo Scudetto alla Roma.",
      en: "\"O Rey di Crocefieschi\". His header against Genoa on 8 May 1983 sealed the draw that mathematically clinched the Scudetto for Roma."
    }
  },
  {
    id: "turone",
    name: "Maurizio Turone",
    role: { it: "Difensore centrale", en: "Centre-back" },
    row: "back", face: { x: 64.1, y: 20.2 },
    stats: { it: "Difensore della rosa Scudetto.", en: "Defender in the Scudetto squad." },
    fact: {
      it: "Legato per sempre alla Roma per il celebre \"gol annullato\" del maggio 1981, in questa stagione contribuì ancora alla difesa della squadra tricolore.",
      en: "Forever tied to Roma for the famous \"disallowed goal\" of May 1981, he still contributed to the defence of the title-winning side."
    }
  },
  {
    id: "nela",
    name: "Sebino Nela",
    role: { it: "Terzino sinistro", en: "Left-back" },
    row: "back", face: { x: 73.3, y: 20.4 },
    stats: { it: "28 presenze · 2 gol in Serie A.", en: "28 apps · 2 goals in Serie A." },
    fact: {
      it: "Terzino tutta corsa, elemento fisso della difesa a quattro di Liedholm. Cresciuto nel vivaio, era già una bandiera a soli 22 anni.",
      en: "Non-stop full-back and fixture in Liedholm's back four. A youth product who had already become a fan favourite at just 22."
    }
  },
  {
    id: "nappi",
    name: "Michele Nappi",
    role: { it: "Difensore", en: "Defender" },
    row: "back", face: { x: 82.5, y: 20.2 },
    stats: { it: "Difensore della rosa Scudetto.", en: "Defender in the Scudetto squad." },
    fact: {
      it: "Difensore duttile, arrivato nella capitale l'anno del tricolore per rinforzare la retroguardia giallorossa.",
      en: "Versatile defender who joined the capital club in the title-winning season to reinforce the giallorossi back line."
    }
  },

  // ============ MIDDLE ROW (in piedi al centro) — y ~ 39% ============
  {
    id: "tessari",
    name: "Ezio Tessari",
    role: { it: "Allenatore in seconda", en: "Assistant coach" },
    row: "middle", face: { x: 10.4, y: 35.9 },
    stats: { it: "Braccio destro di Liedholm.", en: "Liedholm's right-hand man." },
    fact: {
      it: "Vice del Barone Liedholm, curava la preparazione tattica settimanale e la gestione dei calci piazzati.",
      en: "Deputy to Baron Liedholm, he oversaw weekly tactical preparation and set-piece routines."
    }
  },
  {
    id: "prohaska",
    name: "Herbert Prohaska",
    role: { it: "Regista · Mezzala", en: "Playmaker · Inside midfielder" },
    row: "middle", face: { x: 18.9, y: 35.1 },
    stats: { it: "26 presenze · 3 gol in Serie A · Nazionale austriaco.", en: "26 apps · 3 goals in Serie A · Austrian international." },
    fact: {
      it: "\"Schneckerl\" per i tifosi austriaci: eleganza in mezzo al campo e un impatto tattico decisivo nel dominio a centrocampo della squadra tricolore.",
      en: "\"Schneckerl\" to Austrian fans: midfield elegance and a decisive tactical impact in the title-winning team's midfield dominance."
    }
  },
  {
    id: "righetti",
    name: "Ubaldo Righetti",
    role: { it: "Difensore centrale", en: "Centre-back" },
    row: "middle", face: { x: 27.9, y: 35.2 },
    stats: { it: "12 presenze in Serie A · Prodotto del vivaio.", en: "12 apps in Serie A · Academy product." },
    fact: {
      it: "Emerso dal vivaio giallorosso durante la stagione dello Scudetto, sarebbe diventato titolare fisso della difesa negli anni successivi.",
      en: "Broke through from the Roma academy during the Scudetto season, later becoming a regular in the defence."
    }
  },
  {
    id: "superchi",
    name: "Franco Superchi",
    role: { it: "Portiere · Riserva", en: "Goalkeeper · Reserve" },
    row: "middle", face: { x: 37.0, y: 34.6 },
    stats: { it: "Secondo portiere della rosa.", en: "Second-choice goalkeeper." },
    fact: {
      it: "Portiere esperto che ricopriva il ruolo di dodicesimo, garantendo copertura e leadership nello spogliatoio.",
      en: "Experienced back-up goalkeeper providing depth and dressing-room leadership."
    }
  },
  {
    id: "liedholm",
    name: "Nils Liedholm",
    role: { it: "Allenatore", en: "Head coach" },
    row: "middle", face: { x: 46.7, y: 34.2 },
    stats: { it: "Vincitore dello Scudetto 1982/83 · \"Il Barone\".", en: "1982/83 Serie A champion · \"The Baron\"." },
    fact: {
      it: "Il Barone svedese conquistò con la Roma il secondo Scudetto della storia giallorossa, quarantuno anni dopo il primo. La sua difesa a zona e il centrocampo raffinato fecero scuola in Italia.",
      en: "The Swedish Baron delivered Roma's second-ever Scudetto, forty-one years after the first. His zonal defence and refined midfield play set a standard in Italian football."
    }
  },
  {
    id: "tancredi",
    name: "Franco Tancredi",
    role: { it: "Portiere titolare", en: "First-choice goalkeeper" },
    row: "middle", face: { x: 55.9, y: 34.5 },
    stats: { it: "30 presenze in Serie A · 23 clean sheets.", en: "30 apps in Serie A · 23 clean sheets." },
    fact: {
      it: "Muro dello Scudetto: solo 22 gol subiti in 30 partite di campionato, cifra fondamentale per la conquista del titolo.",
      en: "The Scudetto wall: just 22 goals conceded in 30 league matches, a decisive number in the title chase."
    }
  },
  {
    id: "falcao",
    name: "Paulo Roberto Falcão",
    role: { it: "Regista · \"Ottavo Re di Roma\"", en: "Playmaker · \"Eighth King of Rome\"" },
    row: "middle", face: { x: 65.5, y: 34.1 },
    stats: { it: "27 presenze · 7 gol in Serie A · 39 presenze totali.", en: "27 apps · 7 goals in Serie A · 39 total apps." },
    fact: {
      it: "Il centrocampista brasiliano orchestrò dall'alto la stagione tricolore. La città lo ribattezzò \"Ottavo Re di Roma\" per la classe con cui guidò la squadra allo Scudetto.",
      en: "The Brazilian midfielder conducted the title-winning season from the middle of the pitch. The city crowned him \"Eighth King of Rome\" for his class and leadership."
    }
  },
  {
    id: "maldera",
    name: "Aldo Maldera",
    role: { it: "Terzino sinistro · Rigorista", en: "Left-back · Penalty taker" },
    row: "middle", face: { x: 74.5, y: 34.3 },
    stats: { it: "Terzino titolare della difesa a zona.", en: "First-choice full-back in the zonal defence." },
    fact: {
      it: "Nazionale campione del mondo 1982, portò a Roma esperienza e qualità sulla fascia sinistra. Rigorista di grande freddezza.",
      en: "1982 World Cup winner, he brought experience and quality to Roma's left flank. A cold-blooded penalty taker."
    }
  },
  {
    id: "colucci",
    name: "Ernesto Colucci",
    role: { it: "Preparatore atletico", en: "Athletic trainer" },
    row: "middle", face: { x: 83.5, y: 34.3 },
    stats: { it: "Preparatore atletico dello Scudetto.", en: "Athletic trainer of the Scudetto side." },
    fact: {
      it: "Curò la condizione fisica del gruppo per tutta la stagione, portando la squadra a chiudere il campionato imbattuta nelle ultime undici gare.",
      en: "Managed the squad's fitness throughout the season, helping the team close the league unbeaten in its final eleven matches."
    }
  },

  // ============ FRONT ROW (seduti) — y ~ 48% ============
  {
    id: "boldorini",
    name: "Loris Boldorini",
    role: { it: "Massaggiatore", en: "Massage therapist" },
    row: "front", face: { x: 8.9, y: 58.2 },
    stats: { it: "Storico massaggiatore giallorosso.", en: "Longtime giallorossi masseur." },
    fact: {
      it: "Figura storica dello staff Roma, con lo spogliatoio dello Scudetto e delle grandi notti europee giallorosse.",
      en: "A historic figure in the Roma staff, present in the dressing room of the Scudetto and Roma's great European nights."
    }
  },
  {
    id: "valigi",
    name: "Claudio Valigi",
    role: { it: "Centrocampista", en: "Midfielder" },
    row: "front", face: { x: 17.7, y: 57.8 },
    stats: { it: "13 presenze in Serie A.", en: "13 apps in Serie A." },
    fact: {
      it: "Centrocampista di corsa e sostanza, utilizzato da Liedholm come cambio a partita in corso.",
      en: "Energetic and hard-working midfielder used by Liedholm as an impact substitute during matches."
    }
  },
  {
    id: "iorio",
    name: "Maurizio Iorio",
    role: { it: "Attaccante", en: "Forward" },
    row: "front", face: { x: 27.0, y: 57.7 },
    stats: { it: "22+3 presenze · 5 gol in Serie A.", en: "22+3 apps · 5 goals in Serie A." },
    fact: {
      it: "Vice-Pruzzo e prezioso subentrante offensivo: 5 gol pesanti in campionato per il primo attacco alternativo giallorosso.",
      en: "Pruzzo's deputy and a valuable attacking sub: 5 crucial league goals as Roma's alternative striking option."
    }
  },
  {
    id: "bconti",
    name: "Bruno Conti",
    role: { it: "Ala destra", en: "Right winger" },
    row: "front", face: { x: 36.1, y: 57.5 },
    stats: { it: "26 presenze · 3 gol in Serie A · Campione del mondo 1982.", en: "26 apps · 3 goals in Serie A · 1982 World Cup winner." },
    fact: {
      it: "Reduce dal Mondiale spagnolo vinto con l'Italia, illuminò le fasce dell'Olimpico con dribbling, cross e giocate decisive per il tricolore.",
      en: "Fresh from Italy's 1982 World Cup triumph, he lit up the Olimpico wings with dribbling, crosses and match-winning play in the title race."
    }
  },
  {
    id: "alicicco",
    name: "Ernesto Alicicco",
    role: { it: "Medico Sociale", en: "Team doctor" },
    row: "front", face: { x: 45.2, y: 57.7 },
    stats: { it: "Medico sociale della Roma dello Scudetto.", en: "Team doctor of the Scudetto Roma." },
    fact: {
      it: "Storico medico della squadra, garantì la disponibilità dei titolari nelle fasi decisive della stagione.",
      en: "Longtime team doctor, he kept the starters available through the season's decisive weeks."
    }
  },
  {
    id: "giovannelli",
    name: "Stefano Giovannelli",
    role: { it: "Difensore · Giovane", en: "Defender · Youth" },
    row: "front", face: { x: 54.7, y: 57.8 },
    stats: { it: "Prodotto del settore giovanile.", en: "Academy product." },
    fact: {
      it: "Giovane cresciuto a Trigoria, aggregato in prima squadra nella stagione del tricolore.",
      en: "Trigoria youth product, promoted to the first team in the Scudetto season."
    }
  },
  {
    id: "vierchowod",
    name: "Pietro Vierchowod",
    role: { it: "Difensore centrale", en: "Centre-back" },
    row: "front", face: { x: 64.3, y: 57.6 },
    stats: { it: "30 presenze in Serie A · Nazionale italiano.", en: "30 apps in Serie A · Italy international." },
    fact: {
      it: "Roccia della difesa, velocità e cattiveria agonistica al servizio di Liedholm. Uno dei più forti stopper del calcio italiano di sempre.",
      en: "Rock of the defence, combining pace and grit under Liedholm. One of the finest stoppers Italian football has produced."
    }
  },
  {
    id: "ancelotti",
    name: "Carlo Ancelotti",
    role: { it: "Centrocampista centrale", en: "Central midfielder" },
    row: "front", face: { x: 73.5, y: 57.5 },
    stats: { it: "22+1 presenze · 2 gol in Serie A.", en: "22+1 apps · 2 goals in Serie A." },
    fact: {
      it: "Interno di centrocampo intelligente e di grande visione, sarebbe diventato uno degli allenatori più vincenti della storia del calcio mondiale.",
      en: "Intelligent, visionary central midfielder who would later become one of the most decorated coaches in world football history."
    }
  },
  {
    id: "rossi",
    name: "Luciano Rossi",
    role: { it: "Massaggiatore", en: "Massage therapist" },
    row: "front", face: { x: 82.3, y: 57.5 },
    stats: { it: "Storico massaggiatore giallorosso.", en: "Longtime giallorossi masseur." },
    fact: {
      it: "Coppia inseparabile con Boldorini, ha accompagnato la squadra in ogni allenamento e trasferta della stagione tricolore.",
      en: "Inseparable partner of Boldorini, he was alongside the squad in every training session and away trip of the title-winning season."
    }
  },
];

// Signature hotspots — approximate positions of visible autographs on the LANDSCAPE framed print.
// User can refine positions via the Edit Mode.
export const SIGNATURES = [
  { id: "sig-liedholm", playerId: "liedholm", pos: { x: 10, y: 10 }, label: "Liedholm" },
  { id: "sig-dibartolomei", playerId: "dibartolomei", pos: { x: 22, y: 10 }, label: "Di Bartolomei" },
  { id: "sig-tancredi", playerId: "tancredi", pos: { x: 30, y: 12 }, label: "Tancredi" },
  { id: "sig-prohaska", playerId: "prohaska", pos: { x: 38, y: 10 }, label: "Prohaska" },
  { id: "sig-turone", playerId: "turone", pos: { x: 46, y: 12 }, label: "Turone" },
  { id: "sig-chierico", playerId: "chierico", pos: { x: 54, y: 10 }, label: "Chierico" },
  { id: "sig-falcao", playerId: "falcao", pos: { x: 62, y: 12 }, label: "Falcão" },
  { id: "sig-ancelotti", playerId: "ancelotti", pos: { x: 70, y: 10 }, label: "Ancelotti" },
  { id: "sig-vierchowod", playerId: "vierchowod", pos: { x: 78, y: 12 }, label: "Vierchowod" },
  { id: "sig-nela", playerId: "nela", pos: { x: 86, y: 12 }, label: "Nela" },
  { id: "sig-nappi", playerId: "nappi", pos: { x: 88, y: 22 }, label: "Nappi" },
  { id: "sig-pruzzo", playerId: "pruzzo", pos: { x: 84, y: 42 }, label: "Pruzzo" },
  { id: "sig-conti", playerId: "bconti", pos: { x: 40, y: 62 }, label: "B. Conti" },
  { id: "sig-iorio", playerId: "iorio", pos: { x: 24, y: 68 }, label: "Iorio" },
  { id: "sig-scarnecchia", playerId: "scarnecchia", pos: { x: 12, y: 82 }, label: "Scarnecchia" },
];
